export default "__VITE_ASSET__D1h8T7xs__"